import React from 'react';
import st from './StickerWithTabButton.module.scss';
import Sticker from '../sticker/Sticker';
import { TabButton, Type as T } from "@infobis/ui-styles-utils";
import cn from "classnames";
import ChartHeader from "@elements/chart/ChartHeader";
import LoadingBox from '../loading/LoadingBox';

export type TabOption = {
    id: string,
    label: string
}

type ExtendedTabButtonProps = {
    width?: number | string
    height?: number | string
} & Omit<React.ComponentProps<typeof TabButton>, 'selected' | 'values' | 'clickHandler'>

type ExtendedStickerProps = {
    height?: number | string
} & React.ComponentProps<typeof Sticker>

type StickerWithTabButtonProps = {
    options: TabOption[]
    stickerProps?: ExtendedStickerProps
    tabButtonProps?: ExtendedTabButtonProps
    children: React.ReactNode
    selectedId: string
    setSelectedId: (id: string) => void
    title: React.ReactNode
    loading?: boolean
    error?: boolean
    ErrorPage?: () => React.ReactNode
}

const StickerWithTabButton = (props: StickerWithTabButtonProps) => {
    const {
        stickerProps: {
            className = '',
            height,
            style = {},
            ...restStickerProps
        } = {},
        tabButtonProps: {
            className: tabButtonCls,
            width: tabButtonWidth = '25%',
            height: tabButtonHeight,
            style: tabButtonStyle,
            ...restTabButtonProps
        } = {},
        children,
        options,
        setSelectedId,
        selectedId,
        title,
        loading,
        ErrorPage,
        error
    } = props;

    const renderContent = () => {
        if (loading) return <LoadingBox borderRadius={'10'} />
        if (error && ErrorPage) return <ErrorPage />

        return (
            <>
                <div className={st['sticker-top']}>
                    <ChartHeader className={st['title']}>{title}</ChartHeader>
                    <TabButton size={T.Size.SMALL}
                               selected={selectedId}
                               clickHandler={setSelectedId}
                               values={options}
                               className={cn(st['switcher'], tabButtonCls)}
                               style={{height: tabButtonHeight, width: tabButtonWidth, ...tabButtonStyle}}
                               {...restTabButtonProps}
                    />
                </div>
                {children}
            </>
        )
    }

    return (
        <Sticker className={cn(st['sticker'], className)} style={{height, ...style}} {...restStickerProps}>
            {renderContent()}
        </Sticker>
    )
}

export default StickerWithTabButton